export default __webpack_public_path__ + "static/media/ng1.a61e2fae.jpg";